export const userDescriptives = [
    'Agile',
    'Amazing',
    'Amusing',
    'Artistic',
    'Assertive',
    'Admirable',
    'Bashful',
    'Boisterous',
    'Brash',
    'Brave',
    'Buff',
    'Brawny',
    'Brilliant',
    'Blissful',
    'Charming',
    'Clever',
    'Cool',
    'Cunning',
    'Curious',
    'Chill',
    'Creative',
    'Compassionate',
    'Competent',
    'Dapper',
    'Daring',
    'Deft',
    'Delightful',
    'Determined',
    'Discrete',
    'Dazzling',
    'Earnest',
    'Elated',
    'Energetic',
    'Experienced',
    'Eager',
    'Elegant',
    'Esteemed',
    'Exotic',
    'Fastidious',
    'Friendly',
    'Funny',
    'Fast',
    'Fabulous',
    'Fancy',
    'Feisty',
    'Flawless',
    'Gifted',
    'Generous',
    'Gentle',
    'Goofy',
    'Gregarious',
    'Gleeful',
    'Gleaming',
    'Gracious',
    'Happy',
    'Honest',
    'Humble',
    'Helpful',
    'Hasty',
    'Inquisitive',
    'Inspiring',
    'Impressive',
    'Incredible',
    'Intelligent',
    'Intrepid',
    'Jovial',
    'Jaunty',
    'Joyful',
    'Keen',
    'Kind',
    'Knowledgable',
    'Lively',
    'Lanky',
    'Lovely',
    'Luminous',
    'Mellow',
    'Merry',
    'Musical',
    'Mysterious',
    'Modest',
    'Magnificent',
    'Majestic',
    'Nifty',
    'Nimble',
    'Noteworthy',
    'Orderly',
    'Outgoing',
    'Outstanding',
    'Ornate',
    'Optimistic',
    'Pleasant',
    'Popular',
    'Posh',
    'Practical',
    'Prudent',
    'Playful',
    'Polite',
    'Proud',
    'Quick',
    'Regal',
    'Reliable',
    'Respectful',
    'Revered',
    'Ridiculous',
    'Radiant',
    'Sarcastic',
    'Sassy',
    'Saucy',
    'Sly',
    'Snazzy',
    'Sophisticated',
    'Spirited',
    'Stoic',
    'Sweet',
    'Terrific',
    'Thoughtful',
    'Tremendous',
    'Trustworthy',
    'Tricky',
    'Unbreakable',
    'Valiant',
    'Vigilant',
    'Vivacious',
    'Victorious',
    'Virtuous',
    'Wonderful',
    'Zealous',
    'Zany'
]

export const userSpiritAnimals = [
    'Aardvark',
    'Ant',
    'Antelope',
    'Armadillo',
    'Alligator',
    'Badger',
    'Bear',
    'Beluga',
    'Bison',
    'Bobcat',
    'Buffalo',
    'Butterfly',
    'Cat',
    'Chameleon',
    'Chicken',
    'Chimp',
    'Cougar',
    'Coyote',
    'Chipmunk',
    'Crocodile',
    'Caribou',
    'Cobra',
    'Crab',
    'Crane',
    'Dolphin',
    'Duck',
    'Eagle',
    'Eel',
    'Elk',
    'Emu',
    'Elephant',
    'Ferret',
    'Fox',
    'Flamingo',
    'Finch',
    'Frog',
    'Gecko',
    'Goose',
    'Gorilla',
    'Grasshopper',
    'Gazelle',
    'Groundhog',
    'Hedgehog',
    'Hippo',
    'Hyena',
    'Iguana',
    'Jackal',
    'Jaguar',
    'Kangaroo',
    'Koala',
    'Llama',
    'Lobster',
    'Lark',
    'Lemur',
    'Leopard',
    'Lion',
    'Lynx',
    'Lizard',
    'Meerkat',
    'Mongoose',
    'Macaw',
    'Mallard',
    'Mockingbird',
    'Mouse',
    'Narwhal',
    'Octopus',
    'Orangutan',
    'Ostrich',
    'Ocelot',
    'Orca',
    'Osprey',
    'Otter',
    'Owl',
    'Ox',
    'Panda',
    'Pelican',
    'Platypus',
    'Peacock',
    'Pigeon',
    'Porcupine',
    'Possum',
    'Puma',
    'Quail',
    'Rabbit',
    'Raccoon',
    'Reindeer',
    'Roadrunner',
    'Raven',
    'Robin',
    'Rhinoceros',
    'Salamander',
    'Sea Anemone',
    'Sea Lion',
    'Seahorse',
    'Seal',
    'Shark',
    'Sloth',
    'Sunfish',
    'Swan',
    'Squirrel',
    'Tiger',
    'Turtle',
    'Toucan',
    'Toad',
    'Tortoise',
    'Unicorn',
    'Walrus',
    'Wallaby',
    'Whale',
    'Wolf',
    'Wombat',
    'Yak',
    'Zebra'
]



/** WEBPACK FOOTER **
 ** ./src/constants/UserPersonas.js
 **/